import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface AddPwaTokenResponse extends BackendResponse {}
export interface AddPwaTokenParameters extends NextApiParams {
  deviceId: string;
  fcmToken: string;
  expirationDate: Date;
  pushDisabled: boolean;
}

export const addPwaToken = withNextApi<
  AddPwaTokenResponse,
  AddPwaTokenParameters
>("/cvp/CvpAddPwaToken");
